// extracted by mini-css-extract-plugin
export default {"ride":"Rides_ride__sizS3","_map":"Rides__map__6G-Oe","ride_d":"Rides_ride_d__ja2os","val":"Rides_val__tnOoZ","badges":"Rides_badges__ujBCZ","badge":"Rides_badge__ij5vL"};